module.exports = __webpack_public_path__ + "img/8426ae1.png";